import React, { Fragment } from "react";
import { BodyLarge, Body, spacing } from "@conserveit/blocks";
import PropTypes from "prop-types";
import moment from "moment";
import { Trans } from "@lingui/macro";
import styled from "styled-components";
import getUniqueId from "../../../utils/getUniqueId";

import {
  formatTransition,
  formatAttachments,
  formatBody,
} from "./Comment.utils";

const $Container = styled.div`
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #e8ebed;
  margin-bottom: 12px;
  padding: 12px;
`;

const $Title = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.tight};
`;

const $Date = styled.span`
  font-size: 12px;
  color: #7f8b94;
`;

const $Body = styled.div`
  word-break: break-word;
`;

const $AttachmentLink = styled.a.attrs({ target: "_blank" })`
  color: #1e88e5;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-position: under;
`;

const Comment = ({ author, body, createdAt, updatedAt }) => {
  const transition = formatTransition(body);
  const attachments = formatAttachments(body);
  const created = moment(createdAt).format("DD/MM/YY");
  const updated = moment(updatedAt).format("DD/MM/YY");

  return (
    <$Container>
      <$Title>
        <BodyLarge data-cy="IssuePane-Comments-Author">{author}</BodyLarge>
        {updatedAt && (
          <$Date>
            <Trans id="comment.updated">Updated</Trans> {updated}
          </$Date>
        )}

        {createdAt && !updatedAt && <$Date>{created}</$Date>}
      </$Title>
      <$Body>
        {transition && (
          <Body data-cy="IssuePane-Comments-Body">
            <em>{transition}</em>
          </Body>
        )}
        <Body data-cy="IssuePane-Comments-Body">{formatBody(body)}</Body>
        {attachments.length > 0 && (
          <Fragment>
            <Body>
              <strong>
                <Trans id="comment.attachments">Attachments:</Trans>
              </strong>
            </Body>
            <ul>
              {attachments.map((attachment) => (
                <li key={getUniqueId()}>
                  <$AttachmentLink target="_blank" href={attachment[1]}>
                    {attachment[0]}
                  </$AttachmentLink>
                </li>
              ))}
            </ul>
          </Fragment>
        )}
      </$Body>
    </$Container>
  );
};

Comment.propTypes = {
  author: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
};

Comment.defaultProps = {
  updatedAt: undefined,
};

export default Comment;
